import React, { useState } from 'react';
import Table from '../Table';
import Filter from './Filter';
import { ReportingQueryDto } from 'skychain-reporting-js/lib/dto';
import { format } from 'date-fns';
import { END_OF_WEEK, START_OF_WEEK } from '../../../constants';

const Report = () => {
	const [query, setQuery] = useState<ReportingQueryDto>({
		code: 'user_summary',
		params: [
			'%%',
			format(new Date(START_OF_WEEK * 1000), 'yyyy-MM-dd'),
			format(new Date(END_OF_WEEK * 1000), 'yyyy-MM-dd'),
		],
		page: 1,
		pageSize: 10,
	});

	return (
		<div>
			<Filter query={query} setQuery={setQuery} />
			<Table query={query} setQuery={setQuery} />
		</div>
	);
};

export default Report;
